export default "__VITE_ASSET__ef6a5d40__"